import RewritePopup from '#/components/RewritePopup'
import {createContext, useContext, ReactNode, useState} from 'react'

interface AnalyzeTextContextType {
  isOpen: boolean
  openPopup: () => void
  closePopup: () => void
  onYesCallback: (() => void) | null
  onNoCallback: (() => void) | null
  setYesCallback: (callback: () => void) => void
  setNoCallback: (callback: () => void) => void
  score: number
  setScore: (score: number) => void
}

const AnalyzeTextContext = createContext<AnalyzeTextContextType | undefined>(
  undefined,
)

export const AnalyzeTextProvider = ({children}: {children: ReactNode}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [score, setScore] = useState(0)
  const [onYesCallback, setYesCallback] = useState<(() => void) | null>(null)
  const [onNoCallback, setNoCallback] = useState<(() => void) | null>(null)

  const openPopup = () => setIsOpen(true)
  const closePopup = () => setIsOpen(false)

  return (
    <AnalyzeTextContext.Provider
      value={{
        isOpen,
        openPopup,
        closePopup,
        onYesCallback,
        onNoCallback,
        setYesCallback,
        setNoCallback,
        score,
        setScore,
      }}>
      {children}
      <RewritePopup />
    </AnalyzeTextContext.Provider>
  )
}

export const usePopup = () => {
  const context = useContext(AnalyzeTextContext)
  if (context === undefined) {
    throw new Error('usePopup must be used within a PopupProvider')
  }
  return context
}
